import { ROUTERSDATA } from './all.router';


export const handleGetAllRouter = () => {
  const menuObj = [
    // 车辆管理
    {
      path: "/EntrustManage/list",
      name: "车辆管理",
      index: '0',
      redirect: "/EntrustManage/list",
      children: [
        {
          path: "/EntrustManage/list",
          title: "委托管理",
          meta: {
            title: "委托管理"
          },
          children: [
            {
              path: "/EntrustManage/list",
              title: "委托列表",
              component: () => import("@/views/EntrustList/index.vue"),
              meta: {
                title: "委托列表", icon: "el-icon-more-outline",
              },
            },
          ],
        },
        {
          path: "/SaveManage/list",
          title: "保全管理",
          children: [
            {
              path: "/SaveManage/list",
              title: "保全列表",
              component: () => import(/* webpackChunkName: "list" */ "@/views/SaveManage/list.vue"),
              meta: {
                title: "保全列表", icon: "el-icon-more-outline",
              },
            },
            {
              path: "/SaveManage/Servicing",
              title: "整备列表",
              component: () => import(/* webpackChunkName: "Servicing" */ "@/views/SaveManage/Servicing.vue"),
              meta: { title: "整备列表", icon: "el-icon-more-outline", },
            },
            {
              path: "/SaveManage/saveFail",
              title: "保全失败列表",
              component: () => import(/* webpackChunkName: "bqlist3" */ "@/views/SaveManage/saveFail.vue"),
              meta: { title: "保全失败列表", icon: "el-icon-more-outline", },
            },
          ],
          meta: {
            title: "保全管理",
            icon: "el-icon-more-outline",
          },
        },
        {
          path: "/deal/paymentList",
          title: "成交管理",
          meta: {
            title: "成交管理",
            icon: "el-icon-more-outline",
          },
          children: [
            {
              path: "/deal/paymentList",
              title: "待付款列表",
              component: () => import("@/views/deal/paymentList.vue"),
              meta: { title: "待付款列表", icon: "el-icon-more-outline", },
            },
            {
              path: "/deal/carList",
              title: "待提车列表",
              component: () => import("@/views/deal/carList.vue"),
              meta: { title: "待提车列表", icon: "el-icon-more-outline", },
            },
          ],
        },
        {
          path: "/transfer/waitTransfer",
          title: "过户管理",
          children: [
            {
              path: "/transfer/waitTransfer",
              title: "待过户列表",
              component: () => import("@/views/transfer/waitTransfer.vue"),
              meta: {
                title: "待过户列表",
                icon: "el-icon-more-outline",
              },
            },
            {
              path: "/transfer/alreadyTransfer",
              title: "已过户列表",
              component: () => import("@/views/transfer/alreadyTransfer.vue"),
              meta: {
                title: "已过户列表",
                icon: "el-icon-more-outline",
              },
            },
          ],
          meta: {
            title: "过户管理",
            icon: "el-icon-more-outline",
          },
        },
        {
          path: "/Query/carList",
          title: "查询",
          children: [
            {
              path: "/Query/carList",
              title: "车辆列表",
              component: () => import("@/views/Query/carList.vue"),
              meta: {
                title: "车辆列表",
                icon: "el-icon-more-outline",
              },
            },
            {
              path: "/Query/trailer",
              title: "拖车列表",
              component: () => import("@/views/Query/trailer.vue"),
              meta: {
                title: "车辆列表",
                icon: "el-icon-more-outline",
              },
            },
          ],
          meta: {
            title: "查询",
            isLink: false,
            isHide: false,
            isKeepAlive: false,
            isAffix: false,
            isIframe: false,
            icon: "el-icon-more-outline",
          },
        }
      ],
      meta: {
        title: "车辆管理",
        icon: "el-icon-s-home",
      },
    },
    // 拍卖管理
    {
      path: "/AuctionManage/SetUp",
      name: "拍卖管理",
      index: "1",
      children: [
        {
          path: "/AuctionManage/SetUp",
          title: "拍卖会管理",
          meta: {
            title: "拍卖会管理",
            icon: "el-icon-more-outline",
          },
          children: [

            {
              path: "/AuctionManage/SetUp",
              title: "拍卖会设定",
              component: () => import("@/views/AuctionManage/SetUp.vue"),
              meta: { title: "拍卖会设定", icon: "el-icon-more-outline", },
            },
          ]
        },
        {
          path: "/AuctionManage/upmanage",
          title: "明拍管理",
          meta: {
            title: "明拍管理",
            icon: "el-icon-more-outline",
          },
          children: [
            {
              path: "/AuctionManage/UpbeatList",
              title: "上拍管理",
              meta: {
                title: "上拍管理",
                icon: "el-icon-more-outline",
              },
              children: [
                {
                  path: "/AuctionManage/WaitUpbeatList",
                  title: "待上拍列表",
                  component: () => import("@/views/AuctionManage/WaitUpbeatList.vue"),
                  meta: { title: "待上拍列表", icon: "el-icon-more-outline", },
                },
                {
                  path: "/AuctionManage/UpbeatList",
                  title: "上拍列表",
                  component: () => import("@/views/AuctionManage/UpbeatList.vue"),
                  meta: { title: "上拍列表", icon: "el-icon-more-outline", },
                },

              ],
            },
            {
              path: "/AuctionManage/Pauction",
              title: "上拍分类",
              meta: {
                title: "上拍分类",
                icon: "el-icon-more-outline",
              },
              children: [
                // {
                //   path: "/AuctionType/Pauction",
                //   title: "普通拍卖管理",
                //   component: () => import("@/views/AuctionType/Pauction.vue"),
                //   meta: { title: "普通拍卖管理", icon: "el-icon-more-outline", },
                // },
                {
                  path: "/AuctionType/FixedPrice",
                  title: "一口价管理",
                  component: () => import("@/views/AuctionType/FixedPrice.vue"),
                  meta: { title: "一口价管理", icon: "el-icon-more-outline", },
                },
                {
                  path: "/AuctionType/Special",
                  title: "专场拍卖管理",
                  component: () => import("@/views/AuctionType/Special.vue"),
                  meta: { title: "专场拍卖管理", icon: "el-icon-more-outline", },
                },
                {
                  path: "/AuctionType/alreadyUp",
                  title: "已上拍列表",
                  component: () => import("@/views/AuctionType/alreadyUp.vue"),
                  meta: { title: "已上拍列表", icon: "el-icon-more-outline", },
                },
              ],
            },
          ],
        },
        {
          path: "/AuctionType/darkPicture",
          title: "暗拍管理",
          meta: {
            title: "暗拍管理",
            icon: "el-icon-more-outline",
          },
          children: [
            {
              path: "/AuctionType/darkPicture/pauction",
              title: "待上拍列表",
              component: () => import("@/views/AuctionType/darkPicture/pauction.vue"),
              meta: { title: "待上拍列表", icon: "el-icon-more-outline", },
            },
            {
              path: "/AuctionType/darkPicture/already",
              title: "已上拍列表",
              component: () => import("@/views/AuctionType/darkPicture/already.vue"),
              meta: { title: "已上拍列表", icon: "el-icon-more-outline", },
            },
          ],
        },
      ],
      meta: {
        title: "拍卖管理",
        icon: "el-icon-more-outline",
      },
    },
    // 审核管理
    {
      path: "/Audit/Damage",
      name: "审核管理",
      index: "2",
      meta: { title: "审核管理", icon: "el-icon-more-outline" },
      children: [
        {
          path: "/Audit/Damage",
          title: "车辆审核",
          children: [
            {
              path: "/Audit/Damage",
              title: "保全审核",
              component: () => import("@/views//Audit/Damage.vue"),
              meta: { title: "保全审核", icon: "el-icon-more-outline", },
            },
            {
              path: "/Audit/Reorganize",
              title: "整备审核",
              component: () => import("@/views/Audit/Reorganize.vue"),
              meta: { title: "整备审核", icon: "el-icon-more-outline", },
            },
            {
              path: "/Audit/Security",
              title: "保全失败",
              component: () => import("@/views//Audit/Security.vue"),
              meta: { title: "保全失败", icon: "el-icon-more-outline", },
            },
            {
              path: "/Audit/Transfer",
              title: "过户审核",
              component: () => import("@/views/Audit/Transfer.vue"),
              meta: { title: "过户审核", icon: "el-icon-more-outline", },
            },
          ],
          meta: { title: "车辆审核", icon: "el-icon-more-outline", },
        },
        {
          path: "/Mission/Firstpayment",
          title: "财务审核",
          children: [
            {
              path: "/Mission/Firstpayment",
              title: "首款支付审核",
              component: () => import("@/views/Mission/Firstpayment.vue"),
              meta: { title: "首款支付审核", icon: "el-icon-more-outline", },
            },
            {
              path: "/Mission/Incentive",
              title: "奖励审核",
              component: () => import("@/views/Mission/Incentive.vue"),
              meta: { title: "奖励审核", icon: "el-icon-more-outline", },
            },
            {
              path: "/Mission/Trailer",
              title: "拖车审核",
              component: () => import("@/views/Mission/Trailer.vue"),
              meta: { title: "拖车审核", icon: "el-icon-more-outline", },
            },
            {
              path: "/Mission/personal",
              title: "个人费用审核",
              component: () => import("@/views/Mission/personal.vue"),
              meta: { title: "个人费用审核", icon: "el-icon-more-outline", },
            },
            {
              path: "/Mission/Maintenancecost",
              title: "整备费用审核",
              component: () => import("@/views/Mission/Maintenancecost.vue"),
              meta: { title: "整备费用审核", icon: "el-icon-more-outline", },
            },
            {
              path: "/Mission/Carmodel",
              title: "车款和保证金收款",
              component: () => import("@/views/Mission/Carmodel.vue"),
              meta: { title: "车款和保证金收款", icon: "el-icon-more-outline", },
            },
            {
              path: "/Mission/Transfer",
              title: "过户材料邮寄审核",
              component: () => import("@/views/Mission/Transfer.vue"),
              meta: { title: "过户材料邮寄审核", icon: "el-icon-more-outline", },
            },
            {
              path: "/Mission/vehicle",
              title: "车主过户押金退款",
              component: () => import("@/views/Mission/vehicle.vue"),
              meta: { title: "车主过户押金退款", icon: "el-icon-more-outline", },
            },
            {
              path: "/Mission/Membertransfer",
              title: "会员过户押金退款",
              component: () => import("@/views/Mission/Membertransfer.vue"),
              meta: { title: "会员过户押金退款", icon: "el-icon-more-outline", },
            },
          ],
          meta: { title: "财务审核", con: "el-icon-more-outline", },
        }
      ],
    },
    // 会员管理
    {
      path: "/Member/ShowUserList",
      name: "会员管理",
      children: [
        {
          path: "/Member/ShowUserList",
          title: "会员管理",
          children: [
            {
              path: "/Member/ShowUserList",
              title: "会员列表",
              component: () => import("@/views/Member/ShowUserList.vue"),

              meta: {
                title: "会员列表",
                icon: "el-icon-more-outline",
              },
            },
          ],
          meta: {
            title: "会员管理",
            icon: "el-icon-more-outline",
          },
        },
        {
          path: "/Member/PutMarginlist",
          title: "保证金管理",
          children: [
            {
              path: "/Member/PutMarginlist",
              title: "收保证金列表",
              component: () => import("@/views/Member/PutMarginlist.vue"),
              children: null,
              meta: {
                title: "收保证金列表",
                icon: "el-icon-more-outline",
              },
            },
            {
              path: "/Member/PushMarginlist",
              title: "退保证金列表",
              component: () => import("@/views/Member/PushMarginlist.vue"),
              children: null,
              meta: {
                title: "退保证金列表",
                icon: "el-icon-more-outline",
              },
            },
            {
              path: "/Member/Marginfreezelist",
              title: "保证金冻结列表",
              component: () => import("@/views/Member/Marginfreezelist.vue"),
              children: null,
              meta: {
                title: "保证金冻结列表",
                icon: "el-icon-more-outline",
              },
            },
            {
              path: "/Member/Transferdepositfreezelist",
              title: "过户押金列表",
              component: () => import("@/views/Member/Transferdepositfreezelist.vue"),
              children: null,

              meta: {
                title: "过户押金列表",
                icon: "el-icon-more-outline",
              },
            },
          ],
          meta: {
            title: "保证金管理",
            icon: "el-icon-more-outline",
          },
        },
      ],
      index: "3",
      meta: {
        title: "会员管理",
        icon: "el-icon-s-home",
      },
    },
    // 报价管理
    {
      path: "/Quotation",
      name: "报价管理",
      index: "4",
      children: [
        {
          path: "/Quotation",
          title: "报价管理",
          meta: { title: "报价管理", icon: "el-icon-more-outline", },
          children: [
            {
              path: "/Quotation",
              title: "平安报价",
              component: () => import("@/views/Quotation/index.vue"),
              children: null,
              meta: { title: "平安报价", icon: "el-icon-more-outline", type: '平安' },
            },
            {
              path: "/Quotation1",
              title: "人保报价",
              component: () => import("@/views/Quotation/index.vue"),
              children: null,
              meta: { title: "人保报价", icon: "el-icon-more-outline", type: '人保' },
            },
            {
              path: "/Quotation2",
              title: "太保报价",
              component: () => import("@/views/Quotation/index.vue"),
              children: null,
              meta: { title: "太保报价", icon: "el-icon-more-outline", type: '太保' },
            },
            {
              path: "/Quotation4",
              title: "渠道",
              component: () => import("@/views/Quotation/index.vue"),
              children: null,
              meta: { title: "渠道", icon: "el-icon-more-outline", type: '其他' },
            },
            {
              path: "/Quotation3",
              title: "其他报价",
              component: () => import("@/views/Quotation/index.vue"),
              meta: { title: "其他报价", icon: "el-icon-more-outline", type: '其他' },
            },
            {
              path: "/Quotation5",
              title: "二手车",
              component: () => import("@/views/Quotation/index.vue"),
              meta: { title: "二手车", icon: "el-icon-more-outline", type: '二手车' },
            },

          ],
        },
        {
          path: "/Quotation/list",
          title: "中标管理",
          children: [
            {
              path: "/Quotation/list1",
              title: "平安中标",
              component: () => import("@/views/Quotation/list.vue"),
              children: null,
              meta: { title: "平安中标", icon: "el-icon-more-outline", type: '平安' },
            },
            {
              path: "/Quotation/list2",
              title: "人保中标",
              component: () => import("@/views/Quotation/list.vue"),
              children: null,
              meta: { title: "人保中标", icon: "el-icon-more-outline", type: '人保' },
            },
            {
              path: "/Quotation/list3",
              title: "其他中标",
              component: () => import("@/views/Quotation/list.vue"),
              meta: { title: "其他中标", icon: "el-icon-more-outline", type: '其他' },
            },
            {
              path: "/Quotation/list4",
              title: "渠道",
              component: () => import("@/views/Quotation/index.vue"),
              children: null,
              meta: { title: "渠道", icon: "el-icon-more-outline", type: '其他' },
            },
            {
              path: "/Quotation/list5",
              title: "二手车",
              component: () => import("@/views/Quotation/index.vue"),
              children: null,
              meta: { title: "二手车", icon: "el-icon-more-outline", type: '二手车' },
            },

          ],
          meta: { title: "报价管理2", icon: "el-icon-more-outline", },
        },
      ],
      meta: { title: "报价管理", icon: "el-icon-s-home", },
    },
    // 系统管理
    {
      path: "/User/Userlist",
      name: "系统管理",
      index: "5",
      meta: { title: "系统管理", icon: "el-icon-more-outline" },
      children: [
        {
          path: "/User/Userlist",
          title: "人员管理",
          children: [
            {
              path: "/User/Userlist",
              title: "员工管理",
              component: () => import("@/views/User/Userlist.vue"),
              children: null,
              meta: { title: "员工管理", icon: "el-icon-more-outline", },
            },
            {
              path: "/User/IntranetUserlist",
              title: "内网会员管理",
              component: () => import("@/views/User/IntranetUserlist.vue"),
              children: null,
              meta: { title: "内网会员管理", icon: "el-icon-more-outline", },
            },
            {
              path: "/User/appuser",
              title: "app协议内容",
              component: () => import("@/views/User/appuser.vue"),
              children: null,
              meta: { title: "app协议内容", icon: "el-icon-more-outline", },
            }
          ],
          meta: { title: "用户管理", icon: "el-icon-more-outline", },
        },

        {
          path: "/Authority/UserAuthority",
          title: "权限管理",
          children: [
            {
              path: "/Authority/UserAuthority",
              title: "角色菜单管理",
              component: () => import("@/views/Authority/UserAuthority.vue"),
              meta: { title: "角色菜单管理", icon: "el-icon-more-outline", },
            },
            {
              path: "/Authority/AuthorityManage",
              title: "用户权限管理",
              component: () => import("@/views/Authority/AuthorityManage.vue"),
              children: null,
              meta: { title: "用户权限管理", icon: "el-icon-more-outline", },
            },
            {
              path: "/Authority/UserManage",
              title: "用户管理",
              component: () => import("@/views/Authority/UserManage.vue"),
              children: null,
              meta: { title: "用户管理", icon: "el-icon-more-outline", },
            },
            {
              path: "/Authority/MenuManage",
              title: "菜单管理",
              component: () => import("@/views/Authority/MenuManage.vue"),
              children: null,
              meta: { title: "菜单管理", icon: "el-icon-more-outline", },
            },
            {
              path: "/Authority/RoleList",
              title: "权限管理",
              component: () => import("@/views/Authority/RoleList.vue"),
              children: null,
              meta: { title: "权限管理", icon: "el-icon-more-outline", },
            },
            /* {
                path: "/Authority/Vehicle",
                title: "车辆权限",
                component: () => import("@/views/Authority/Vehicle.vue"),
                children: null,
                meta: { title: "2222222222", icon: "el-icon-more-outline", },
            },
            {
                path: "/Authority/auction",
                title: "拍卖管理",
                component: () => import("@/views/Authority/auction.vue"),
                children: null,
                meta: { title: "2222222222", icon: "el-icon-more-outline", },
            },
            {
                path: "/Authority/audit",
                title: "审核管理",
                component: () => import("@/views/Authority/audit.vue"),
                children: null,
                meta: { title: "2222222222", icon: "el-icon-more-outline", },
            },
            {
                path: "/Authority/member",
                title: "会员权限",
                component: () => import("@/views/Authority/member.vue"),
                children: null,
                meta: { title: "2222222222", icon: "el-icon-more-outline", },
            },
            {
                path: "/Authority/Quotation",
                title: "报价权限",
                component: () => import("@/views/Authority/Quotation.vue"),
                children: null,
                meta: { title: "2222222222", icon: "el-icon-more-outline", },
            }, */

          ],
          meta: { title: "权限管理", icon: "el-icon-more-outline", },
        },
        {
          path: "/Authority/Banner",
          title: "轮播管理",
          children: [
            {
              path: "/Authority/Banner",
              title: "轮播图管理",
              component: () => import("@/views/Authority/Banner.vue"),
              children: null,
              meta: { title: "轮播图管理", icon: "el-icon-more-outline", },
            }
          ],
          meta: { title: "轮播管理", icon: "el-icon-more-outline", },
        },
        {
          path: "/system/system",
          title: "系统配置",
          children: [
            {
              path: "/system/system",
              title: "帮助中心",
              component: () => import("@/views/system/system.vue"),
              children: null,
              meta: { title: "帮助中心", icon: "el-icon-more-outline", },
            },
            // {
            //     path: "/system/configuration",
            //     title: "配置app",
            //     component: () => import("@/views/system/configuration.vue"),
            //     children: null,
            //     meta: { title: "配置app", icon: "el-icon-more-outline", },
            // },
            {
              path: "/system/about",
              title: "关于我们",
              component: () => import("@/views/system/about.vue"),
              children: null,
              meta: { title: "关于我们", icon: "el-icon-more-outline", },
            },
            {
              path: "/system/SystemSetting",
              title: "系统设置",
              component: () => import("@/views/system/SystemSetting.vue"),
              children: null,
              meta: { title: "系统设置", icon: "el-icon-more-outline", },
            },
            {
              path: "/system/AfterSalesInstructions",
              title: "售后说明",
              component: () => import("@/views/system/AfterSalesInstructions.vue"),
              children: null,
              meta: { title: "售后说明", icon: "el-icon-more-outline", },
            },
            {
              path: "/system/BiddingRules",
              title: "竞价规则",
              component: () => import("@/views/system/BiddingRules.vue"),
              children: null,
              meta: { title: "竞价规则", icon: "el-icon-more-outline", },
            },
            {
              path: "/system/CompanyProfile",
              title: "公司简介",
              component: () => import("@/views/system/CompanyProfile.vue"),
              children: null,
              meta: { title: "公司简介", icon: "el-icon-more-outline", },
            },
            {
              path: "/system/DotInformation",
              title: "网点信息",
              component: () => import("@/views/system/DotInformation.vue"),
              children: null,
              meta: { title: "网点信息", icon: "el-icon-more-outline", },
            },

            {
              path: "/system/InterpretationOfDispute",
              title: "争议解释",
              component: () => import("@/views/system/InterpretationOfDispute.vue"),
              children: null,
              meta: { title: "争议解释", icon: "el-icon-more-outline", },
            },
            {
              path: "/system/LegalStatement",
              title: "法律声明",
              component: () => import("@/views/system/LegalStatement.vue"),
              children: null,
              meta: { title: "法律声明", icon: "el-icon-more-outline", },
            },
            {
              path: "/system/MattersNeedingAttention",
              title: "注意事项",
              component: () => import("@/views/system/MattersNeedingAttention.vue"),
              children: null,
              meta: { title: "注意事项", icon: "el-icon-more-outline", },
            },
            {
              path: "/system/PrivacyPolicy",
              title: "隐私政策",
              component: () => import("@/views/system/PrivacyPolicy.vue"),
              children: null,
              meta: { title: "隐私政策", icon: "el-icon-more-outline", },
            },
            {
              path: "/system/QualificationCertificate",
              title: "资质证明",
              component: () => import("@/views/system/QualificationCertificate.vue"),
              children: null,
              meta: { title: "资质证明", icon: "el-icon-more-outline", },
            },
            {
              path: "/system/ServiceAgreement",
              title: "服务协议",
              component: () => import("@/views/system/ServiceAgreement.vue"),
              children: null,
              meta: { title: "服务协议", icon: "el-icon-more-outline", },
            },

          ],
          meta: { title: "系统配置", icon: "el-icon-more-outline", },
        },
        {
          path: "/institution/index",
          title: "机构管理",
          children: [
            {
              path: "/institution/index",
              title: "机构管理",
              component: () => import("@/views/institution/index.vue"),
              children: null,
              meta: { title: "机构管理", icon: "el-icon-more-outline", },
            },
            {
              path: "/WarehouseManagement/index.vue",
              title: "库房管理",
              component: () => import("@/views/WarehouseManagement/index.vue"),
              meta: { title: "库房管理", icon: "el-icon-more-outline", },
            }
          ],
          meta: { title: "机构管理", icon: "el-icon-more-outline", },
        }

      ],
    },
  ];
  return menuObj
}


/**
 * 将多个权限列表 合并为一个 去除重复
 */
export const handleRoleList2OneList = (args = []) => {
  let _arr = []
  args = args.map((item) => {
    item.map((item2) => {
      _arr.push(item2)
    })
  })
  let _arr2 = []
  _arr.forEach((item) => {
    if (_arr2.filter((item2) => item2.id == item.id).length == 0) {
      _arr2.push(item)
    }
  })

  return _arr2;
}

/***
 * 将结果转为树形结构 menus 使用
 */
export const handleRoute2Menus = (router2menu, list = [], parentKey = '', rootKey = "") => {
  let arr = [];

  arr = list.sort((a, b) => a.sort - b.sort).filter((item) => {
    return item.parentKey === parentKey;
  }).map((item) => {
    if (!item.parentKey) {
      rootKey = item.menuKey;
    }
    item.name = item.menuName;
    item.path = item.routerPath;
    router2menu[item.menuKey] = {
      rootKey,
      parentKey: item.parentKey,
      data: item
    }
    item.children = handleRoute2Menus(router2menu, list, item.menuKey, rootKey).sort((a, b) => a.sort - b.sort);
    return item;
  })
  return arr;
}
export const _handleRoute2Menus = (list = []) => {
  let router2menu = {}
  let menus = handleRoute2Menus(router2menu, list, '')
  return {
    menus,
    router2menu
  }
}




/**
 * 通过接口返回 生成菜单 路由 和 按钮
 * @param {*} arr 
 * @returns 
 */
export const routerRun = async (arr) => {
  let args = arr.map((item) => {
    return item.menus;
  })
  let list = handleRoleList2OneList(args);

  // 将列表内容的 进行填充
  list = list.map((item) => {
    if (item.menuType == 1) {
      if (ROUTERSDATA[item.viewPath]) {
        item.component = ROUTERSDATA[item.viewPath];
      }
      item.path = item.routerPath;
    }
    return item
  })
  // 将结果转成tree 菜单 只要 目录和菜单
  let { menus, router2menu } = _handleRoute2Menus(list.filter((item) => {
    return item.menuType == 1 || item.menuType == 0;
  }), '');

  let routers = list.filter((item) => {
    return item.menuType == 1 && item.component;
  }).map((item) => {
    return {
      path: item.path,
      component: item.component,
      meta: {
        name: item.menuName,
        menuKey: item.menuKey,
        show: item.show,
      }
    }
  })
  let btns = list.filter((item) => {
    return item.menuType == 2;
  })

  // menus = menus.filter((item) => {
  //   return item.menuKey != '系统管理'
  // })
  // menus.push(...SYSRouter.menus)

  // routers.push(...SYSRouter.routers)
  return {
    menus: menus,
    routers: routers,
    router2menu,
    btns: btns
  };
}